export const defaultState = () => {
    return {
        show: false,
        allwaysPerformAssessment: false,
        disableRouterGuards: false,
        disableMRXErrorChecking: false,
        dontSkipPanels: false,
        dontFilterResponses: false,
        logScores: false,
        multipleUploadsOfData: false,
        oneClickPanels: false,
        rdtTestMode: false,
        showTranslationTokens: false,
        showAllAssessments: false,
        useSliderForTapper: false,
        triggerQueueingError: false,
        copyTranslation: false,
        showUploadButton: false
    }
}

const state = defaultState()
export default state
